import { render, staticRenderFns } from "./PreWarnRuleForm.vue?vue&type=template&id=3dd3bbcb&"
import script from "./PreWarnRuleForm.vue?vue&type=script&lang=js&"
export * from "./PreWarnRuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd3bbcb')) {
      api.createRecord('3dd3bbcb', component.options)
    } else {
      api.reload('3dd3bbcb', component.options)
    }
    module.hot.accept("./PreWarnRuleForm.vue?vue&type=template&id=3dd3bbcb&", function () {
      api.rerender('3dd3bbcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/epidemic/modules/PreWarnRuleForm.vue"
export default component.exports